<template>
  <div class="asc-analytic-grid">
    <asc-grid-wrapper-header></asc-grid-wrapper-header>
    <asc-ag-grid-filter
      :key="`asc-analytic-grid_${gridId}`"
      :grid-options="agGridOptions"
      :column-defs="getGridColumnDefs"
      :row-data="agGridRowData"
    ></asc-ag-grid-filter>
  </div>
</template>

<script>
import {
  AscAgGridFilter,
  AscAgGridAutocompleteFloatFilter,
  AscTooltipCellRenderer,
} from '@/components/agGrid'
import AscGridWrapperHeader from './AscGridWrapperHeader'
import { AscGridPropsMixin, AscGridMethodsMixin } from '@/components/mixins'
import { stringTextMatcher } from '@/components/agGrid/AgGridHelperMethods'
import { getFilterOptions } from '@/components/agGrid/AgGridOptions'

export default {
  name: 'AscAnalyticGrid',

  components: {
    AscAgGridFilter,
    AscGridWrapperHeader,
    AscAgGridAutocompleteFloatFilter,
    AscTooltipCellRenderer,
  },

  mixins: [AscGridPropsMixin, AscGridMethodsMixin],

  data() {
    return {
      agGridOptions: getFilterOptions(this, {
        defaultColDef: {
          tooltipComponent: 'AscTooltipCellRenderer',
        },
        rowSelection: 'single',
        onGridReady: this.handleGridReady,
        onFirstDataRendered: this.handleFirstDataRendered,
        onGridSizeChanged: this.handleGridSizeChanged,
        onCellClicked: this.handleCellClicked,
      }),
    }
  },

  computed: {
    mappedValues() {
      return this.values
    },
    agGridRowData() {
      this.resetLocalStorage(this.localStorageName)
      return this.mappedValues
    },
    getGridColumnDefs() {
      return [
        {
          headerName: 'Platform',
          field: 'masterModelName',
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: stringTextMatcher,
          },
          floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
          floatingFilterComponentParams: {
            ids: [],
            items: this.getUniqueItems('masterModelName'),
            suppressFilterButton: true,
          },
        },
        {
          headerName: 'Analytic Module',
          field: 'interalName',
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: stringTextMatcher,
          },
          floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
          floatingFilterComponentParams: {
            ids: [],
            items: this.getUniqueItems('interalName'),
            suppressFilterButton: true,
          },
        },
        {
          headerName: 'Current Analytic Version',
          field: 'analyticModuleVersion',
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: stringTextMatcher,
          },
          floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
          floatingFilterComponentParams: {
            ids: [],
            items: this.getUniqueItems('analyticModuleVersion'),
            suppressFilterButton: true,
          },
        },
        {
          headerName: 'Analytic Module Display Name',
          field: 'displayName',
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: stringTextMatcher,
          },
          floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
          floatingFilterComponentParams: {
            ids: [],
            items: this.getUniqueItems('displayName'),
            suppressFilterButton: true,
          },
        },
        {
          headerName: 'Component',
          field: 'componentName',
          filter: 'agTextColumnFilter',
          filterParams: {
            textMatcher: stringTextMatcher,
          },
          floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
          floatingFilterComponentParams: {
            ids: [],
            items: this.getUniqueItems('componentName'),
            suppressFilterButton: true,
          },
        },
      ]
    },
  },

  watch: {
    values() {
      this.handleRefreshColWidths()
    },
  },

  methods: {
    handleCellClicked(event) {
      if (event) {
        this.onOpen(event.data)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-sort-icon {
  color: $primary_black;
  position: absolute;
  top: 14px;
  right: 16px;
}

.asc-filter-icon {
  color: $primary_black;
}
</style>
